import { render, staticRenderFns } from "./tabs-tabs.vue?vue&type=template&id=cdfad45e&scoped=true"
import script from "./tabs-tabs.vue?vue&type=script&lang=js"
export * from "./tabs-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfad45e",
  null
  
)

export default component.exports